import React from 'react';
import styled from 'styled-components';
import { handleResponseLanguage } from '../../../../../../../i18n';

// Components
import CheckBoxWithIcon from './CheckBoxWithIcon';

// Types
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
interface Props {
  question: FlowsQuestion;
}

const SecuritySystemInputComponent: React.FC<
  React.PropsWithChildren<Props>
> = ({ question }) => {
  const {
    field: { onBlur, value },
  } = useFlowInputComponent({ question, defaultValue: false });

  const currentVal = value || false;

  const handleOnSelected = (id: string) => {
    onBlur({ name: question.id, value: !currentVal });
  };

  return (
    <StyledCheckboxWithIcon
      type={question.icon_key || question.field || ''}
      title={handleResponseLanguage(question.title)}
      value={currentVal}
      onSelected={handleOnSelected}
      data-test-id="ProdFac_SecuritySystemsInputComponent"
    />
  );
};

const StyledCheckboxWithIcon = styled(CheckBoxWithIcon)`
  height: 100%;
`;

export default SecuritySystemInputComponent;
